import { render } from "./Circleji.vue?vue&type=template&id=1378d7b8"
const script = {}

import "./Circleji.vue?vue&type=style&index=0&id=1378d7b8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__